import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "mt-5 text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Es ist ein Fehler aufgetreten – bitte versuche es später erneut.")
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Dies ist ein geschlossener Kurs. Du kannst für einen einmaligen Betrag an allen Kursterminen teilnehmen.", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Vom Kurs abmelden ")
const _hoisted_13 = { class: "fa fa-fw fa-spin fa-spinner ms-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Zum Kurs anmelden ")
const _hoisted_17 = { class: "fa fa-fw fa-spin fa-spinner ms-1" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Warteliste verlassen ")
const _hoisted_20 = { class: "fa fa-fw fa-spin fa-spinner ms-1" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Warteliste beitreten ")
const _hoisted_23 = { class: "fa fa-fw fa-spin fa-spinner ms-1" }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = {
  key: 4,
  class: "row"
}
const _hoisted_26 = { class: "col-12 col-lg-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "Du musst dich mit deinem buggyFit-Konto einloggen, um dich zu Kursen anmelden zu können.", -1)
const _hoisted_28 = { class: "col-12 col-lg-6" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Du hast noch kein buggyFit-Konto? Nutze deine kostenlose Probestunde und registrier dich jetzt – du bist dann automatisch zu diesem Kurs angemeldet:", -1)
const _hoisted_31 = ["href"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Du hast noch kein buggyFit-Konto? Dies ist ein geschlossener Kurs, zu dem du dich "),
  /*#__PURE__*/_createElementVNode("b", null, "erst anmelden kannst, wenn du schon ein buggyFit-Konto besitzt"),
  /*#__PURE__*/_createTextVNode(". Wenn das noch nicht der Fall ist, kannst du dir hier ein Konto anlegen: ")
], -1)
const _hoisted_34 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_CourseOrderable = _resolveComponent("CourseOrderable")!
  const _component_LoginModal = _resolveComponent("LoginModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.enrollmentRequested)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnrollmentRequest && _ctx.onEnrollmentRequest(...args)), ["prevent"]))
          }, "Zu diesem Kurs anmelden")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_Alert, { type: "danger" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]))
              : (_ctx.isAuthenticated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.isClosedCourseAndUserOnlyHasInsufficientCredit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_CourseOrderable, {
                            course: _ctx.result.course,
                            classes: {'h-100': true},
                            onOrderSuccess: _ctx.onOrderSuccess
                          }, null, 8, ["course", "onOrderSuccess"])
                        ]))
                      : (_ctx.isEnrolled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("a", {
                              class: "btn btn-lg btn-danger",
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPerformWithdrawal && _ctx.onPerformWithdrawal(...args)), ["prevent"]))
                            }, [
                              _hoisted_12,
                              _withDirectives(_createElementVNode("i", _hoisted_13, null, 512), [
                                [_vShow, _ctx.loadingWithdraw]
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.canEnroll)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (_ctx.result?.enrollmentIntents.course.creditRequired)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Dies ist ein geschlossener Kurs."))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    class: "btn btn-lg btn-success",
                                    href: "#",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPerformEnrollment && _ctx.onPerformEnrollment(...args)), ["prevent"]))
                                  }, [
                                    _hoisted_16,
                                    _withDirectives(_createElementVNode("i", _hoisted_17, null, 512), [
                                      [_vShow, _ctx.loadingEnroll]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isWaiting)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("a", {
                                    class: _normalizeClass(["btn btn-lg btn-danger", {'mt-3': _ctx.canEnroll}]),
                                    href: "#",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPerformLeaveWaitlist && _ctx.onPerformLeaveWaitlist(...args)), ["prevent"]))
                                  }, [
                                    _hoisted_19,
                                    _withDirectives(_createElementVNode("i", _hoisted_20, null, 512), [
                                      [_vShow, _ctx.loadingLeaveWaitlist]
                                    ])
                                  ], 2)
                                ]))
                              : (_ctx.canJoinWaitlist)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("a", {
                                      class: "btn btn-lg btn-secondary",
                                      href: "#",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPerformJoinWaitlist && _ctx.onPerformJoinWaitlist(...args)), ["prevent"]))
                                    }, [
                                      _hoisted_22,
                                      _withDirectives(_createElementVNode("i", _hoisted_23, null, 512), [
                                        [_vShow, _ctx.loadingJoinWaitlist]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highestPriorityErrors, (error) => {
                              return (_openBlock(), _createBlock(_component_Alert, {
                                key: error.key,
                                class: "mt-3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(error.errorMessage), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ], 64))
                  ]))
                : (_ctx.courseNotEnrollable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHighestPriorityErrorsOfTag('course'), (error) => {
                        return (_openBlock(), _createBlock(_component_Alert, {
                          key: error.key
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.errorMessage), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("a", {
                          href: "#",
                          class: "btn btn-primary",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.loginModalShown = true), ["prevent"]))
                        }, "Anmelden")
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        (_ctx.courseIsEnrollableDuringRegistration)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("a", {
                                href: _ctx.registerWithCoursePrefilledUrl,
                                class: "btn btn-secondary"
                              }, "Registrieren", 8, _hoisted_31)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("a", {
                                href: _ctx.registerWithRegionPrefilledUrl,
                                class: "btn btn-secondary"
                              }, "Registrieren", 8, _hoisted_34)
                            ]))
                      ])
                    ]))
        ])),
    _createVNode(_component_LoginModal, {
      shown: _ctx.loginModalShown,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loginModalShown = false)),
      onLogin: _ctx.onLogin
    }, null, 8, ["shown", "onLogin"])
  ]))
}